import { numberCounter } from '$utils/numberCounter';

window.Webflow = window.Webflow || [];
window.Webflow.push(() => {
  numberCounter();
});
